import BusinessManagerRoutes from '@cobliteam/business-manager/src/routes';
import ChecklistsRoutes from '@cobliteam/checklists/src/routes';
import type { Location } from '@cobliteam/common-types';
import EconomicDrivingRoutes from '@cobliteam/economic-driving/src/routes';
import ExpenseRoutes from '@cobliteam/expenses/src/routes';
import GeofencesRoutes from '@cobliteam/geofences/src/routers';
import MaintenanceRoutes from '@cobliteam/maintenance/src/routes';
import MediaRoutes from '@cobliteam/media/src/routes';
import PathAssociationRoutes from '@cobliteam/path-association/src/routes';
import PrismicRoutes from '@cobliteam/prismic/src/routes';
import ProductivityRoutes from '@cobliteam/productivity/src/routes';
import ProofOfConclusionRoutes from '@cobliteam/proof-of-conclusion/src/routes';
import NewReportsRoutes from '@cobliteam/reports/src/routes';
import RoadSpeedRoutes from '@cobliteam/road-speed/src/routes';
import TriggersRoutes from '@cobliteam/triggers/src/routes';
import type React from 'react';
import CommonRouters from './common';
import CrmRoutes from './crm';
import DevicesPage from './devices';
import DriverRoutes from './drivers';
import FinesRoutes from './fines';
import FuelCardRoutes from './fuel-card';
import GroupsRoutes from './groups';
import HomeRoutes from './home';
import ImagesMatchRoutes from './images-match';
import IntegrationsRoutes from './integrations';
import LivestreamRoutes from './livestream';
import MonitoringRoutes from './monitoring';
import NewsRoutes from './news';
import PassageHistoryRoutes from './passage-history';
import ReportsRoutes from './reports';
import RoutingRoutes from './routing';
import SafetyDashboardRoutes from './safety-dashboard';
import SafetyRankingRoutes from './safety-ranking';
import SettingsRoutes from './settings';
import SpeedingRoutes from './speeding';
import TrackingRoutes from './tracking';
import TrainingRoutes from './training';
import VehicleRoutes from './vehicles';
export interface IRoute {
  path: Location;
  title?: string;
  featureFlag?: string;
  component?: React.LazyExoticComponent<React.ComponentType<any>>;
  render?: (props: any) => React.ReactNode;
  routes?: IRoute[];
  accessDeniedDescription?: string;
  exact?: boolean;
  hasCameraFlag?: boolean;
  hasRedeCan?: boolean; // hasRedeCan is false when the user has no valid vehicles
  hasGroupsRestriction?: boolean; // hasGroupsRestriction is false when the user has no valid groups or vehicles
}

const routes = [
  ...PrismicRoutes,
  ...ChecklistsRoutes,
  ...DevicesPage,
  ...SafetyRankingRoutes,
  ...SafetyDashboardRoutes,
  ...DriverRoutes,
  ...FuelCardRoutes,
  ...HomeRoutes,
  ...IntegrationsRoutes,
  ...MaintenanceRoutes,
  ...MediaRoutes,
  ...MonitoringRoutes,
  ...PassageHistoryRoutes,
  ...EconomicDrivingRoutes,
  ...ProductivityRoutes,
  ...ReportsRoutes,
  ...NewReportsRoutes,
  ...RoutingRoutes,
  ...SettingsRoutes,
  ...SpeedingRoutes,
  ...TrackingRoutes,
  ...VehicleRoutes,
  ...CommonRouters,
  ...TriggersRoutes,
  ...ProofOfConclusionRoutes,
  ...CrmRoutes,
  ...BusinessManagerRoutes,
  ...TrainingRoutes,
  ...LivestreamRoutes,
  ...RoadSpeedRoutes,
  ...ExpenseRoutes,
  ...PathAssociationRoutes,
  ...ImagesMatchRoutes,
  ...GroupsRoutes,
  ...NewsRoutes,
  ...FinesRoutes,
  ...GeofencesRoutes,
];

export default routes;
